import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { useExpertAIReviewManagerHook } from "./ExpertAIReviewManagerHook";
const ExpertAIReviewContext = /*#__PURE__*/createContext({});
export const ExpertAIReviewContextProvider = ({
  children
}) => {
  const expertAIReviewManager = useExpertAIReviewManagerHook();
  const contextValue = useMemo(() => ({
    ...expertAIReviewManager
  }), [expertAIReviewManager]);
  return /*#__PURE__*/React.createElement(ExpertAIReviewContext.Provider, {
    value: contextValue
  }, children);
};
export const useExpertAIReviewContext = () => {
  return useContext(ExpertAIReviewContext);
};
ExpertAIReviewContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};